// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"257":"762f7fa8","658":"147cf465","688":"0c0ef21a","744":"94776a1a","842":"ff84edcf"}[chunkId] + ".chunk.js";
};